import { ArticleBranchErpSyncChanges } from '@texas/api/endpoints/variantsApi';
import FinalizeError from '../../../api/dto/variant/finalizeErrorTypes';

export function branchCanFinalize(
  branchIdsToSync: number[],
  validations: FinalizeError[] | null,
) {
  return (
    branchIdsToSync.length > 0 &&
    !branchIdsToSync.some((b) => branchHasErrors(b, validations)) &&
    validations?.filter((v) => !v.branchId).length === 0
  );
}

export function branchIsModifiedSinceSync(
  branchId: number,
  syncChanges: ArticleBranchErpSyncChanges[] | null,
) {
  if (!syncChanges) return false;
  return (
    syncChanges.find(
      (s) =>
        s.branchId === branchId &&
        s.modifications.some((m) => m.modifiedFields.length > 0),
    ) !== undefined
  );
}

export function branchHasErrors(
  branchId: number,
  validations: FinalizeError[] | null,
) {
  return (validations?.filter((v) => v.branchId === branchId) ?? []).length > 0;
}

export type BranchIdentifier =
  | '000'
  | 'RHK'
  | 'RCH'
  | '503'
  | '505'
  | 'RTR'
  | '500'
  | 'RIN'
  | 'ECO'
  | '506'
  | '507'
  | '504';

export function getBranchColor(branch: BranchIdentifier) {
  const lower = branch.toLowerCase();
  switch (lower) {
    case '000':
    case 'rhk':
    case 'rch':
    case '503':
    case '505':
    case 'rtr':
    case '500':
    case 'rin':
    case 'eco':
    case '506':
    case '507':
    case '504':
      return `var(--chakra-colors-branches-${lower})`;
    default:
      return 'var(--chakra-colors-branches-000)';
  }
}
